import { Transition, Variants } from 'motion/react'

const EASE_OUT: Transition['ease'] = [0.22, 1, 0.36, 1]

export const VIEW_TRANSITION: Transition = { duration: 0.28, ease: EASE_OUT }

export const SPOTLIGHT_VIEW_VARIANTS: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  visible: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.96, transition: { duration: 0.18 } }
}

export const ALL_APPS_VIEW_VARIANTS: Variants = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 32, transition: { duration: 0.18 } }
}

export const BACK_TOGGLE_VARIANTS: Variants = {
  hidden: { opacity: 0, x: -16 },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -16, transition: { duration: 0.15 } }
}

export const SPOTLIGHT_CARD_STAGGER = 0.05
